import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ExportRequest } from '../components/odata-filter/models/export-request';
import { ApiVersions } from './api-version';
import {
  DynamicData,
  ModalConfirmationComponent,
  ModalConfirmationModel,
} from '../components/modal-confirmation/modal-confirmation.component';
import { ExportConfirmationComponent } from '../components/modal-confirmation/export-confirmation/export-confirmation.component';
import { ViewContext } from '../components/odata-filter/models/view-context';

@Injectable()
export class ExportService extends BaseService {
  constructor() {
    super();
  }

  private exportPaths: { viewContext: ViewContext; path: string }[] = [
    { viewContext: ViewContext.People, path: 'export/people' },
    { viewContext: ViewContext.Teams, path: 'export/teams' },
    { viewContext: ViewContext.TeamRosters, path: 'export/team-rosters' },
    { viewContext: ViewContext.TeamSurvey, path: 'export/team-surveys' },
    { viewContext: ViewContext.Forms, path: 'export/forms' },
    { viewContext: ViewContext.PersonScenarioReport, path: 'export/person-scenario' },
    { viewContext: ViewContext.AllCredentialingDetailsReport, path: 'export/person-credential' },
    { viewContext: ViewContext.CredentialingDetailsReport, path: 'export/person-credential' },
    { viewContext: ViewContext.AllPaymentRecordsReport, path: 'export/payment-records' },
    { viewContext: ViewContext.CredentialPaymentRecordsReport, path: 'export/payment-records' },
    { viewContext: ViewContext.AllInvoiceReport, path: 'export/all-invoices' },
    {
      viewContext: ViewContext.PersonCredentialApplicationReport,
      path: 'export/person-credential-application',
    },
    {
      viewContext: ViewContext.AllInProgressPersonCredentialApplications,
      path: 'export/person-credential-application',
    },
    {
      viewContext: ViewContext.InProgressPersonCredentialApplications,
      path: 'export/person-credential-application',
    },
  ];

  public exportRequest(request: ExportRequest, viewContext: ViewContext) {
    request.oDataQuery = this.getBaseApiUrl(ApiVersions.v1_0).concat(request.oDataQuery);
    const body = JSON.stringify(request);
    const path = this.exportPaths.find((x) => x.viewContext == viewContext).path;
    this.post(path, body).subscribe(() => {
      let data: ModalConfirmationModel = {
        simpleDialog: true,
        title: 'Export file is processing',
        action: null,
        delete: false,
        okButtonText: 'GOT IT',
        okButtonId: 'modal-export-service',
        description: null,
        textMatcherValue: '',
        dynamicData: new DynamicData(ExportConfirmationComponent, null),
      };
      this.dialog.open(ModalConfirmationComponent, {
        data: data,
      });
    });
  }
}
